module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "x-data": "{ open: true }",
      "x-show": "open"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6",
    attrs: {
      "x-show": "open",
      "x-transition:enter": "ease-out duration-300",
      "x-transition:enter-start": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "x-transition:enter-end": "opacity-100 translate-y-0 sm:scale-100",
      "x-transition:leave": "ease-in duration-200",
      "x-transition:leave-start": "opacity-100 translate-y-0 sm:scale-100",
      "x-transition:leave-end": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mt-3 text-center sm:mt-5"
  }, [_c('h3', {
    staticClass: "text-lg leading-6 font-medium text-gray-900"
  }, [_vm._v("\n                    " + _vm._s(_vm.heading) + "\n                ")]), _vm._v(" "), (_vm.description) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('p', {
    staticClass: "text-sm leading-5 text-gray-500",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
  }, [_c('span', {
    staticClass: "flex w-full rounded-md shadow-sm sm:col-start-2"
  }, [_c('button', {
    staticClass: "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 text-base leading-6 font-medium text-white shadow-sm bg-main sm:text-sm sm:leading-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.accept()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.acceptText) + "\n                ")])]), _vm._v(" "), _c('span', {
    staticClass: "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1"
  }, [_c('button', {
    staticClass: "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cancelText) + "\n                ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed inset-0 transition-opacity",
    attrs: {
      "x-show": "open",
      "x-transition:enter": "ease-out duration-300",
      "x-transition:enter-start": "opacity-0",
      "x-transition:enter-end": "opacity-100",
      "x-transition:leave": "ease-in duration-200",
      "x-transition:leave-start": "opacity-100",
      "x-transition:leave-end": "opacity-0"
    }
  }, [_c('div', {
    staticClass: "absolute inset-0 bg-gray-500 opacity-75"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d1838ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/alert.vue
// module id = 292
// module chunks = 1